import { useState } from 'react';

const EU_LOCALES = new Set([
  'en-gb','en-ie','de-de','fr-fr','es-es','it-it','nl-nl',
  'pt-pt','pl-pl','sv-se','nb-no','da-dk','fi-fi','de-at','fr-be','de-ch',
  'et-ee','lv-lv','lt-lt','sk-sk','sl-si','bg-bg','ro-ro','hu-hu','cs-cz',
  'fr-lu','de-li','en-mt','en-cy',
]);

export function CookieBanner({ locale }) {
  const [accepted, setAccepted] = useState(
    () => localStorage.getItem('cookie_consent') === 'true'
  );

  if (!EU_LOCALES.has(locale) || accepted) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: '#13131a', color: '#e8e8f0',
      padding: '14px 24px', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px',
      zIndex: 9999, borderTop: '1px solid #2a2a3a',
    }}>
      <p style={{ margin: 0, fontSize: '13px' }}>
        We use cookies to improve your experience.{' '}
        <a href="/privacy" style={{ color: '#00e5a0' }}>Learn more</a>
      </p>
      <button
        onClick={() => { localStorage.setItem('cookie_consent', 'true'); setAccepted(true); }}
        style={{
          background: '#00e5a0', color: '#000', border: 'none',
          borderRadius: '6px', padding: '8px 20px',
          cursor: 'pointer', fontWeight: 600, fontSize: '13px',
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        Accept
      </button>
    </div>
  );
}
